module.exports = __webpack_public_path__ + "img/status-transit.a7e8014e.svg";